import { Injectable } from '@angular/core';
import { ISignatureDataFormatterService } from '../../interfaces/ISignatureDataFormatterService';

@Injectable({
  providedIn: 'root',
})
export class InveniasSignatureFormatterService implements ISignatureDataFormatterService {
  formatDataPath(fieldType: string, dataPath: string): string {
    return '';
  }
}
